<!-- Back Button -->
<div class="container">
  <div class="text-danger pt-3 cursor-pointer d-none d-lg-block" [routerLink]="'/rewards'">
    <span class="material-icons align-middle fw-bold pe-2">navigate_before</span>
    <span class="font-size-14 fw-bold">Back </span>
  </div>
</div>

<!-- Points Summary -->

<fgb-points-summary-bar [backButtonLink]="'/rewards'" [backButtonTitle]="'Auctions'"></fgb-points-summary-bar>

<!-- Auction Details -->
<fgbcl-auction-details [auctionId]="id"></fgbcl-auction-details>
